module.exports = __webpack_public_path__ + "static/img/14.5240969e.png";